import styled from "styled-components";

// components
import SectionContainer from "core/SectionContainer";

// styles
import breakpoints from "core/breakpoints";

//helpers
import { convertPxToRem } from "frontend/components/helpers";

export const HeroSectionContainer = styled(SectionContainer)`
    > section {
        // Tablet
        @media (min-width: ${breakpoints.tablet.rem}) {
            padding-bottom: ${convertPxToRem({ px: 55 })};
        }
    }
`;
